/* ZIRB LANGSAM — Produktdetailseite · Interaktionen
   (ergänzt zirb-base.js: Reveal, Stepper, Cart-Add, Toast) */
(function(){
  if (window.__zirbProduktInit) return;
  window.__zirbProduktInit = true;

  document.addEventListener('DOMContentLoaded', function(){
    /* ---- Galerie: Thumbnail-Wechsel ---- */
    var main = document.getElementById('pdpMain');
    var stage = main ? main.closest('.pdp-stage__main') : null;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.zirb-section-wrapper .pdp-thumb'));
    var swapToken = 0; /* entwertet ausstehende Timeouts bei schnellen Doppel-Klicks */
    function setMain(btn){
      if(!main) return;
      var full = btn.getAttribute('data-full');
      var isPhoto = btn.getAttribute('data-photo') === '1';
      var token = ++swapToken;
      main.style.opacity = '0';
      setTimeout(function(){
        if(token !== swapToken) return;
        main.src = full;
        main.alt = btn.getAttribute('data-alt') || main.alt;
        main.removeAttribute('srcset');
        if(stage) stage.classList.toggle('is-photo', isPhoto);
        main.style.opacity = '1';
      }, 120);
      thumbs.forEach(function(t){
        t.classList.toggle('active', t === btn);
        t.setAttribute('aria-pressed', t === btn ? 'true' : 'false');
      });
    }
    thumbs.forEach(function(btn){
      btn.addEventListener('click', function(){ setMain(btn); });
    });

    /* ---- Detail-Tabs ---- */
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.zirb-section-wrapper .tab'));
    var panels = Array.prototype.slice.call(document.querySelectorAll('.zirb-section-wrapper .tabpanel'));
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function(t){
          var active = t === tab;
          t.classList.toggle('active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function(p){ p.classList.toggle('active', p.id === id); });
      });
    });

    /* ---- Geschmacksprofil: Balken füllen, wenn sichtbar ---- */
    var tbarWrap = document.querySelector('.zirb-section-wrapper .tbars');
    if(tbarWrap){
      var bars = Array.prototype.slice.call(tbarWrap.querySelectorAll('.tbar'));
      var fired = false;
      function fillBars(){
        if(fired) return;
        var r = tbarWrap.getBoundingClientRect();
        var h = window.innerHeight || document.documentElement.clientHeight;
        if(r.top < h*0.82 && r.bottom > 0){
          fired = true;
          bars.forEach(function(b,i){
            setTimeout(function(){ b.classList.add('in'); }, i*140);
          });
          window.removeEventListener('scroll', fillBars);
        }
      }
      window.addEventListener('scroll', fillBars, {passive:true});
      fillBars();
      setTimeout(function(){ if(!fired){ bars.forEach(function(b){ b.classList.add('in'); }); } }, 2000);
    }
  });
})();
